import type { User } from "@/api/types";

export const AGENCY_ROLES = ["super_admin", "operator"] as const;
export const CLIENT_ROLES = ["client_admin", "client_viewer"] as const;

export function isAgencyUser(user: User | null): boolean {
  return !!user && (AGENCY_ROLES as readonly string[]).includes(user.role);
}

export function isClientUser(user: User | null): boolean {
  return !!user && (CLIENT_ROLES as readonly string[]).includes(user.role);
}

export function canEdit(user: User | null): boolean {
  return !!user && user.role !== "client_viewer";
}

export function isSuperAdmin(user: User | null): boolean {
  return !!user && user.role === "super_admin";
}

export function canManageTenantResources(user: User | null): boolean {
  return !!user && user.role !== "client_viewer" && user.role !== "operator";
}

export function canManageDevices(user: User | null): boolean {
  return !!user && user.role !== "client_viewer";
}
